import PropTypes from "prop-types";
import React from "react";

export default class Arrow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <svg
        onClick={() => this.props.action && this.props.action()}
        width={this.props.width ? this.props.width : "97px"}
        height={this.props.height ? this.props.height : "97px"}
        viewBox="0 0 97 97"
        className={this.props.className}
      >
        <g
          id="Styleguide"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Logo" transform="translate(-980.000000, -500.000000)">
            <g id="Group-16" transform="translate(980.000000, 500.000000)">
              <path
                d="M68.9988074,31.5069601 C58.5803004,36.8622116 48.7617491,41.9104511 38.3046908,47.2849661 C48.9834195,54.7170631 58.577891,61.3942719 68.9988074,68.6469776 L68.9988074,31.5069601 Z M60.3898052,68.7866379 C50.8929169,63.2784824 41.4827691,57.6198309 32.0798497,51.9515476 C28.2777211,49.6591918 28.0560507,46.7708716 31.0823331,43.5960069 C31.63169,43.02051 32.1918896,42.3378599 32.8906331,42.0356638 C45.6800492,36.4913893 58.3538112,30.634083 71.3685118,25.678549 C76.2982679,23.8015622 76.9970114,25.8663681 76.5741511,31.280614 C75.6754223,42.7881441 75.5790439,54.3594845 75.1537741,65.9043375 C75.0224585,69.4837356 74.7851267,72.9740401 68.4771592,72.5707106 C66.4929686,71.6556946 63.2968193,70.4709897 60.3898052,68.7866379 Z"
                id="Fill-8"
                fill="#121A22"
                transform="translate(52.839181, 48.801298) rotate(-180.000000) translate(-52.839181, -48.801298) "
              ></path>
              <circle
                id="Oval"
                stroke="#000000"
                stroke-width="5"
                cx="48.5"
                cy="48.5"
                r="46"
              ></circle>
            </g>
          </g>
        </g>
      </svg>
    );
  }

  static propTypes = {
    className: PropTypes.string,
  };
}
